import { Button, Icon, Tooltip } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import styles from './table.module.scss';
import useDocsIdByBind from '../queries/useDocsIdByBind';
import { documentsActions } from '../store/actions/documents.actions';

export const ExpandedRowDocRelated = ({ record }) => {
  const dispatch = useDispatch();

  const { data: relatedObjects = [], isFetching } = useDocsIdByBind(record?.id);

  return (
    <Tooltip
      title={`Связанные объекты`}
      placement="right"
    >
      <Button
        ghost
        shape="circle"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(documentsActions.setRelatedDocsModal(record));
        }}
      >
        <Icon
          type={isFetching ? 'loading' : 'fork'}
          className={classNames(styles.icon, styles.reminderIcon)}
          style={{ color: !!relatedObjects?.length ? '#0995ed' : '#d7d7d8' }}
        />
      </Button>
    </Tooltip>
  );
};

ExpandedRowDocRelated.propTypes = {
  record: PropTypes.object.isRequired,
};
